module.exports = __webpack_public_path__ + "img/img631.121057b0.png";